import styled from 'styled-components';
import { largeLayout } from '@styles/layout';
import { FullHeightSection } from '@components/Sections/Sections.s';

export const SectionTwoWraper = FullHeightSection.extend`
  position: relative;
`;

export const SectionTwoIsometricContainer = styled.div`
  position: absolute;
  top: 0;
  left: 100%;
  width: ${(680 + 50) * 3}px;
  transform-origin: 0% 0%;
  transform: rotate(55deg) scale(0.5);
  // perspective: 10000px;
`;

export const GridWrapper = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin: auto;
  // transform: rotateY(-26deg);
`;

type GridTileProps = {
  bg: string;
};

export const GridTile = styled.li`
  width: 680px;
  height: 386px;
  margin-right: 50px;
  margin-bottom: 50px;
  transition-duration: .3s;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  background: white;
  transform: scale(1);
  opacity:0.7;
  background-image: url('${(props: GridTileProps) => props.bg}');
  &:hover {
    transform: scale(1.05);
    opacity:1;
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.7);
  }
`;

export const TextWrapper = styled.div`
  width: ${largeLayout.getSize(6)}px;
  margin-top: 25%;
`;


// WEBPACK FOOTER //
// src/app/src/components/SectionTwo/SectionTwo.s.ts